<template>
  <a-layout-content :class="!monitoring ? (isSPCL ? '' : 'p-all') : ''">
    <a-spin :spinning="loading.page">
      <a-row :gutter="16">
        <a-col :xs="24" :lg="16">
          <a-card>
            <div slot="title">
              <span class="d-block">Manifest Surat Perintah Lembur</span>
              <small v-if="basedData.header">{{ basedData.header.no_alokasi }}</small>
            </div>
            <a-popover slot="extra" trigger="focus" placement="bottomRight">
              <span slot="title">Pilih aksi</span>
              <ul class="list-wrapper bordered" slot="content">
                <li v-if="basedData.status == 'Revised'">
                  <a-button type="dashed" class="w-full" icon="edit" @click="editTransaksi">
                    Ubah Data
                  </a-button>
                </li>
                <li v-if="can_cancel">
                  <a-button type="danger" class="w-full" icon="close-square" @click="cancelTransaksi"
                    :loading="loading.cancel">
                    Cancel
                  </a-button>
                </li>
                <li>
                  <a-button size="default" class="w-full" @click="handlePrint" slot="extra" icon="printer"
                    :loading="loading.print">{{ !isMobile ? 'Print Manifest' : '' }}</a-button>
                </li>
              </ul>
              <a-button icon="more">Aksi</a-button>
            </a-popover>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Tanggal Pembuatan / Pembuat</span>
                <span class="list-desc" v-if="basedData.header">{{
                  moment(basedData.header.create_dt).format(getDefaultDateFormat) }} / {{
    basedData.header.tlc_create }}</span>
              </li>
              <li>
                <span class="list-title" for>Atas Perintah</span>
                <span class="list-desc" v-if="basedData.header">{{ basedData.header.commander }}</span>
              </li>
              <li>
                <span class="list-title" for>Pelaksana</span>
                <span class="list-desc" v-if="basedData.header">{{ basedData.header.pelaksana }}</span>
              </li>
              <li>
                <span class="list-title" for>Kode Proyek</span>
                <span class="list-desc" v-if="basedData.header">{{ basedData.header.c_proyek }}</span>
              </li>
              <li>
                <span class="list-title" for>Uraian Tugas</span>
                <span class="list-desc" v-if="basedData.header">{{ basedData.header.uraian }}</span>
              </li>
            </ul>
          </a-card>
          <a-card class="m-top d-flex flex-column nowrap" title="Detil Jadwal Pekerjaan">
            <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="basedData.detail" :pagination="pagination">
              <a-list-item slot="renderItem" slot-scope="item, index">
                <a-card hoverable class="d-flex flex-column nowrap">
                  <!-- <div slot="title" class="d-flex justify-between">
                    <span class="list-title">TLC</span>
                    <a-tag>{{item.c_proyek}}</a-tag>
                  </div> -->
                  <a-list-item-meta>
                    <ul slot="description" class="list-wrapper">
                      <table style="width:100%">
                        <tr>
                          <td>
                            <div class="sjo" style="width:100%">
                              <a-avatar :size="52">{{ index + 1 }}</a-avatar>
                            </div>
                          </td>
                          <td>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="12">
                                <li class="m-remove">
                                  <span class="list-title">Tanggal</span>
                                  <span class="list-desc">{{ item.date }}</span>
                                </li>
                              </a-col>
                              <a-col :xs="24" :lg="12">
                                <li class="m-remove">
                                  <span class="list-title">Estimasi Waktu</span>
                                  <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{
                                    moment(item.end_time,).format("HH:mm") }}</span>
                                </li>
                              </a-col>
                            </a-row>
                            <a-row :gutter="16">
                              <a-col :xs="24" :lg="12">
                                <li class="m-remove">
                                  <span class="list-title">TLC Pelaksana</span>
                                  <span class="list-desc">{{ item.pelaksana }}</span>
                                </li>
                              </a-col>
                              <a-col :xs="24" :lg="12">
                                <li class="m-remove">
                                  <span class="list-title">Lokasi Lembur</span>
                                  <span class="list-desc">{{ item.lokasi }}</span>
                                </li>
                              </a-col>
                            </a-row>
                          </td>
                        </tr>
                      </table>
                    </ul>
                  </a-list-item-meta>
                </a-card>
              </a-list-item>
            </a-list>
          </a-card>
          <a-card class="m-top" v-if="basedData.jenis !== 'Manifest'">
            <div slot="title">Tindakan Manifest</div>

            <a-form :form="form">
              <a-form-item class="m-remove" label="Catatan">
                <a-textarea placeholder="Tulis catatan disini ... " :rows="4" v-decorator="['catatan']" />
              </a-form-item>
              <a-form-item label="Aksi">
                <a-select showSearch v-decorator="['aksi', { rules: [{ required: true }] }]">
                  <a-select-option v-for="item in basedData.aksi" :key="item.aksi">{{ item.aksi }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button @click="handleAction" block type="primary" html-type="submit">Simpan</a-button>
              </a-form-item>
            </a-form>
          </a-card>

        </a-col>
        <a-col :xs="24" :lg="8" :class="isMobile ? 'm-top' : ''">
          <a-collapse activeKey="1" forceRender>
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <span class="margin-remove">Status</span>
                <div>
                  <H-Status :status="basedData.status" />
                  <a-tooltip placement="topRight">
                    <template #title>
                      <span>History</span>
                    </template>
                    <a-button @click="handleHistory" type="default" size="small">
                      <a-icon type="history" />
                    </a-button>
                  </a-tooltip>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="grey">
                  <div class="m-timeline-title">Pembuat - {{ basedData.header ? basedData.header.tlc_create : null }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ basedData.header ? basedData.header.create_dt : null }}</h4>
                    <!--                    <span class="m-text-small">{{data.invoice.keperluan ? data.invoice.keperluan : 'Tidak Ada Keperluan'}}</span>-->
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">CREATED</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  :color="workflow.status === 'On Process' || workflow.status === 'Delivered' ? 'green' : workflow.status === 'Waiting' ? 'grey' : workflow.status === 'Rejected' || workflow.status === 'Revised' ? 'red' : 'grey'"
                  v-for="workflow in basedData.status_app" :key="workflow.step_no">
                  <div class="m-timeline-title">{{ workflow.actor }} - {{ workflow.tlc }}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi !== null">{{ workflow.tanggal_aksi }}</h4>
                    <span class="m-text-small" v-if="workflow.remark">{{ workflow.remark }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <H-Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse :class="'margin-top'" activeKey="1" forceRender>
            <a-collapse-panel key="1">
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="margin-remove">Dokumen Terkait</h4>
              </div>
              <ul class="list-wrapper bordered">
                <li v-for="(dbt, index) in basedData.dokumen_terkait" :key="index">
                  <div slot="title" class="m-display-flex space-between align-middle nowrap">
                    <h4 class="margin-remove m-text-dots">
                      Realisasi SPL
                    </h4>
                    <a class="margin-remove m-text-dots" @click="goToRealisasiSPL(dbt.realisasi_spl_id)">
                      {{ dbt.no_realisasi_spl }}
                    </a>
                    <div><small><b>Pelaksana :</b> {{ dbt.pelaksana }}</small></div>
                    <small><b>Perintah : </b> {{ dbt.commander }}</small>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </a-spin>


    <a-modal v-model="history" @ok="handleHistory" :footer="null">
      <span slot="title">
        <a-icon type="history" />&nbsp;History Status
      </span>

      <ul class="list-wrapper bordered">
        <li v-for="history in basedData.notifikasi" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title">{{ history.as_from }} | {{ history.tlc_from }}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title"
                v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'">
                {{ history.as_from }} | {{ history.tlc_from }}</h3>
              <h3 class="m-remove list-title" v-else>{{ history.as_to }} | {{ history.tlc_to }}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>


  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import Status from "@/components/Status.vue";
export default {
  props: ["id"],
  components: {
    "H-Status": Status
  },
  name: "ManifestSPL",
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  data() {
    return {
      basedData: {},
      pagination: {
        onChange: page => {
          console.log(page);
        },
        pageSize: 5,
        size: "small"
      },
      monitoring: false,
      history: false,
      activeKey: ['1'],
      loading: {
        cancel: false,
        page: false,
        print: false,
      },
      can_cancel: false,
    };
  },
  watch: {
    id() {
      if (this.id) {
        this.fetching();
      }
    }
  },
  created() {
    this.fetching();
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    isSPCL() {
      return this.$route.meta.isSPCL ? true : false
    },
    kodeMenu() {
      return localStorage.getItem('mns_')
    },
  },

  methods: {
    moment,
    async fetching() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "Spl",
        params: {
          id_manifest: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          if (response.data) {
            this.basedData = {
              header: response.data.header[0],
              detail: response.data.detail,
              notifikasi: response.data.notifikasi,
              status_app: response.data.status_app,
              status: response.data.status,
              jenis: response.data.jenis,
              id_manifest: response.data.id_manifest,
              aksi: response.data.aksi,
              dokumen_terkait: response.data.dokumen_terkait
            };
            this.can_cancel = response.data.can_cancel
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    handlePrint() {
      this.loading.print = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "spl/cetak",
        responseType: "blob",
        params: {
          spl_id: this.id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.loading.print = false;
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.$notification.error({
              message: "Error",
              description: "Gangguan System, error code 404!"
            });
          }
          this.loading.print = false;
          //this.$router.go();
        });
    },
    handleHistory(event) {
      this.history = true;
      event.stopPropagation();
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.$notification.error({
            message: "Error",
            description: "Pilih Aksi Terlebih Dahulu!"
          });
          return;
        }
        axios({
          method: "post",
          url: this.$serviceUrl + "spl/approval",
          processData: false,
          data: {
            id_manifest: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : ""
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.$notification.success({
              message: "Sukses",
              description: "Data telah berhasil diproses!"
            });
            Event.$emit("refreshNotification", true);
            this.$router.go();
          })
          .catch(err => {
            err = Object.assign({}, err.response)
            if (err.data.message) {
              this.displayMessageValue("error-basic", err.data.message);
            } else {
              let response = Object.assign({}, err.response);
              this.displayMessageValue("error-other", response);
            }
          });
      });
    },
    editTransaksi() {
      this.$router.push({
        name: "editSPL",
        params: { id: this.id },
      });
    },
    cancelTransaksi() {
      const that = this;
      this.$confirm({
        title: "Are you sure to cancel this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let data = new FormData();
          data.append("spl_id", that.id);
          that.loading.page = true;
          that.asyncAxiosPost("Spl/cancel", "formdata", that.getAuth, data)
            .then(() => {
              that.fetching()
              that.displayMessage("success-cancel");
              that.loading.page = false;
            })
            .catch((err) => {
              console.log(err);
              that.loading.page = false;
            });
        },
        onCancel() { },
      });
    },
    goToRealisasiSPL(id) {
      let result = "manifestRealisasiSpl"
      if (this.kodeMenu == "9") {
        result = "manifestRealisasiSplDir"
      } else if (this.kodeMenu == "4") {
        result = "manifestRealisasiSplHrd"
      } else if (this.kodeMenu == "12") {
        result = "manifestRealisasiSplAL"
      }
      this.$router.push({
        name: result,
        params: { id: id },
      });
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    if (
      this.$router.currentRoute.name == "hrd.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "al.mon.manifest.alokasi" ||
      this.$router.currentRoute.name == "dir.mon.manifest.alokasi"
    ) {
      this.monitoring = true;
    } else {
      this.monitoring = false;
    }
  }
};
</script>

<style></style>
